import { render, staticRenderFns } from "./ModalBankAccountCreate.vue?vue&type=template&id=37446895"
import script from "./ModalBankAccountCreate.vue?vue&type=script&lang=js"
export * from "./ModalBankAccountCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports